import {
  IClientType,
  ICombination,
  IFAQAll,
  IFAQFile,
  IKeyword,
  IQuestionType,
  ISectionAll,
  IUser,
  UserObject
} from "@/types/SPTypes.tsx";
import { DISPATCH_TYPE, RADIO_OPTIONS } from "../utils/enums.js";
import { GeneralActionTypes } from "@/actionTypes/generalActionTypes.ts";

interface GeneralState {
  FAQs: IFAQAll[];
  FAQFiles: IFAQFile[];
  sections: ISectionAll[];
  questionTypes: IQuestionType[];
  clientTypes: IClientType[];
  keywords: IKeyword[];
  combinations: ICombination[];
  radioOption: string;
  currentUser: IUser;
  currentUserEmail: string;
  loadingData: false;
  isLoggedIn: boolean;
  page: string;
}

const initialState: GeneralState = {
  FAQs: [],
  FAQFiles: [],
  sections: [],
  questionTypes: [],
  clientTypes: [],
  keywords: [],
  combinations: [],
  radioOption: RADIO_OPTIONS.ALL,
  currentUser: UserObject,
  currentUserEmail: "",
  loadingData: false,
  isLoggedIn: false,
  page: ""
};

function general(
  state: GeneralState = initialState,
  action: GeneralActionTypes
) {
  switch (action.type) {
    case DISPATCH_TYPE.SET_FAQ_DATA:
      return { ...state, FAQs: action.payload };
    case DISPATCH_TYPE.SET_FAQ_FILES:
      return { ...state, FAQFiles: action.payload };
    case DISPATCH_TYPE.SET_SECTIONS:
      return { ...state, sections: action.payload };
    case DISPATCH_TYPE.SET_QUESTION_TYPES:
      return { ...state, questionTypes: action.payload };
    case DISPATCH_TYPE.SET_CLIENT_TYPES:
      return { ...state, clientTypes: action.payload };
    case DISPATCH_TYPE.SET_KEYWORDS:
      return { ...state, keywords: action.payload };
    case DISPATCH_TYPE.SET_COMBINATIONS:
      return { ...state, combinations: action.payload };
    case DISPATCH_TYPE.SET_CURRENTUSER:
      return { ...state, currentUser: action.payload };
    case DISPATCH_TYPE.SET_IS_LOADING:
      return { ...state, loadingData: action.payload };
    case DISPATCH_TYPE.SET_CURRENTUSER_EMAIL:
      return { ...state, currentUserEmail: action.payload };
    case DISPATCH_TYPE.SET_IS_LOGP:
      return { ...state, isLoggedIn: action.payload };
    default:
      return state;
  }
}

export default general;
